import React from 'react'
import StatusTable from './StatusTable'

export default function SubCategoryStatus() {
  const tableData = (item) => {
    return [
      { image: item.image, type: 'IMAGE' },
      { value: item.name },
      { value: item.subcategoryCode },
      { value: item.category },
      { value: item.description },
      { value: item.remark ? item.remark : '-----' },
      { type: 'STATUS_ENUM', status: item.status },
    ]
  }
  return <StatusTable key="SubCategory" tableHeading={['image', 'name', 'subcategory code', 'category', 'description', 'reason', 'status']} tableData={tableData} module="SUBCATEGORY" />
}
